import React from 'react';
import { useFormikContext } from 'formik';
import { FormGroup, SubmitButton } from '../../../form';
import { InputPassword } from '../../../formikBindings';

const ChangeSitePasswordForm: React.FC = () => {
  const { isSubmitting } = useFormikContext();

  return (
    <>
      <input type="hidden" name="pin" />
      <FormGroup name="password" label="Password" required>
        <InputPassword name="password" disabled={isSubmitting} autoFocus />
      </FormGroup>
      <FormGroup name="confirmPassword" label="Confirm Password" required>
        <InputPassword name="confirmPassword" disabled={isSubmitting} />
      </FormGroup>
      <SubmitButton>Submit</SubmitButton>
    </>
  );
};

export default ChangeSitePasswordForm;
